import classNames from 'classnames'
import { CSSProperties } from 'react'

import { ILoaderProps, Loader } from 'core-components/library/loader/Loader'

import styles from './LoaderOverlay.module.scss'

export interface ILoaderOverlayProps {
  /**
   * Set the visibility of component
   */
  show: boolean
  /**
   * Hide overlay background
   */
  withoutBackground?: boolean
  loaderVisible?: boolean
  /**
   * Size of the Loader
   */
  dimension?: ILoaderProps['dimension']
  /**
   * Size of background
   */
  backgroundSize?: {
    width?: CSSProperties['width']
    height?: CSSProperties['height']
  }
  /**
   * A Class name for component root node
   */
  className?: string
}

export const LoaderOverlay = ({
  show,
  withoutBackground,
  loaderVisible = true,
  dimension,
  backgroundSize,
  className,
}: ILoaderOverlayProps) => (
  <div
    data-testid={'loaderOverlay'}
    style={{ width: backgroundSize?.width, height: backgroundSize?.height }}
    className={classNames(
      className,
      styles.overlay,
      !show && styles.hidden,
      withoutBackground && styles.withoutBackground
    )}
  >
    {loaderVisible ? <Loader dimension={dimension} /> : null}
  </div>
)
